module.exports = __webpack_public_path__ + "static/media/color_prediction.419755bf.svg";